import React from "react";
import { Steps } from "antd";

const { Step } = Steps;

const StepsPostulation = ({steps = [], current, readonly=false}) => {
  return (
    <div className="steps-postulation">
      <Steps size="small" current={current}>
        {steps.map((value, key) => {
          return <Step title={value.title} key={key} />;
        })}
      </Steps>
    </div>
  );
};

export default StepsPostulation;
